import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
// import clsx from 'clsx';
import { useDispatch } from 'react-redux';

import { showSuccessSnackbar } from 'modules/snackbar';

import Autocomplete from '@material-ui/lab/Autocomplete';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';

import CircularProgress from '@material-ui/core/CircularProgress';

const useStyles = makeStyles((theme) => ({
  comboBoxRoot: { width: 250, height: 35, backgroundColor: '#fff' },
  filterSize: { width: 150 },
}));

const NewAutoComplete = (props) => {
  const {
    list = [],
    label = 'NewAutoComplete',
    name = 'NewAutoComplete',
    valueKey,
    labelKey,
    getParam = (f, name) => f,
    params,
    allValue = null,
    alertMessage = undefined,
    // type = 'filter',
    className,
    loading: propsLoading = false,
    ...rest
  } = props;

  const { t } = useTranslation();
  const classes = useStyles();
  const dispatch = useDispatch();

  const [options, setOptions] = useState([]);
  const initValue = params[name] === undefined ? null : params[name];
  const [value, setValue] = useState(initValue);
  const [inputValue, setInputValue] = useState('');
  // const [loading, setLoading] = useState(false);

  const usePrevious = (value) => {
    const ref = useRef();

    useEffect(() => {
      ref.current = value;
    }, [value]);

    return ref.current;
  };
  const prevList = usePrevious(list);

  useEffect(() => {
    let newList = [];
    if (JSON.stringify(prevList) !== JSON.stringify(list)) {
      for (let val of list) {
        if (!!val[valueKey]) {
          newList.push({
            [valueKey]: String(val[valueKey]),
            [labelKey]: String(val[labelKey]),
          });
          if (initValue === val[valueKey]) {
            setInputValue(val[labelKey]);
          }
        }
      }
      setOptions(newList);
    }
    // eslint-disable-next-line
  }, [list]);

  useEffect(() => {
    if (!!params[name] === false) {
      handleReset();
    } // eslint-disable-next-line
  }, [params[name]]);

  useEffect(() => {
    if (!!value) {
      getParam({ ...params, [name]: value }, name);
    } else {
      getParam({ ...params, [name]: allValue }, name);
    }
    // eslint-disable-next-line
  }, [value]);

  const handleReset = () => {
    setValue(initValue);
    setInputValue('');
  };

  // const handleOnInputChange = (newInputValue) => {
  //   if (!!newInputValue) {
  //     setInputValue(newInputValue);
  //   }
  // };

  const handleOnClose = (reason) => {
    if (reason === 'blur') {
      if (inputValue !== '' && !options.includes(inputValue)) {
        handleClickSnackbar({
          message: !!alertMessage
            ? alertMessage
            : t('자동완성input', { label: label }),
          option: { type: 'error' },
        });
      }
      setValue(inputValue);
    }
  };

  const handleClickSnackbar = useCallback((snackbarOptions) => {
    dispatch(showSuccessSnackbar(snackbarOptions));
    //eslint-disable-next-line
  }, []);

  return (
    <div>
      <Autocomplete
        classes={{ root: classes.comboBoxRoot }}
        loading={propsLoading || options.length === 0}
        options={options}
        getOptionLabel={(option) =>
          !!option[labelKey] ? option[labelKey] : ''
        }
        getOptionSelected={(option, value) => option[valueKey] === value}
        renderInput={(params) => {
          return (
            <TextField
              {...params}
              label={label}
              variant="outlined"
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <>
                    {propsLoading && (
                      <CircularProgress color="inherit" size={20} />
                    )}
                    {params.InputProps.endAdornment}
                  </>
                ),
              }}
            />
          );
        }}
        onChange={(event, newValue) => {
          setValue(!!newValue ? newValue[valueKey] : '');
        }}
        // onInputChange={(event, newInputValue) => {
        //   handleOnInputChange(newInputValue);
        // }}
        onClose={(e, reason) => handleOnClose(reason)}
        size="small"
        autoComplete
        // inputValue={inputValue}
        // value={value}
        {...rest}
      />
    </div>
  );
};
export default NewAutoComplete;
